var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndrawNotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 115,
    viewBox: "0 0 171 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_notify_re_65on",
    clipPath: "url(#clip0_9235_2389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M155.97 110.813L151.086 96.074C151.086 96.074 156.458 101.446 156.458 105.854L155.494 95.6608C155.494 95.6608 158.249 99.3799 157.973 105.027C157.698 110.675 155.97 110.813 155.97 110.813Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M51.0881 97.3923L46.3215 83.0079C46.3215 83.0079 51.5644 88.2508 51.5644 92.5527L50.6234 82.6046C50.6234 82.6046 53.3121 86.2343 53.0432 91.7461C52.7743 97.2578 51.0881 97.3923 51.0881 97.3923Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M125.485 104.03C125.493 113.492 106.726 110.582 83.7502 110.602C60.7747 110.622 42.2913 113.564 42.2831 104.102C42.2749 94.6397 61.0353 92.5655 84.0109 92.5457C106.986 92.5258 125.477 94.5678 125.485 104.03Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M171 110.596H0V111.029H171V110.596Z",
    fill: "#C4C4CD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M109.383 91.251H106.379L104.95 79.6652H109.383V91.251Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M103.9 90.3927H110.027V94.0401H100.586V93.7064C100.586 92.8276 100.935 91.9847 101.557 91.3633C102.178 90.7418 103.021 90.3927 103.9 90.3927Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M131.461 108.351H128.458L127.028 96.7653H131.461V108.351Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M125.979 107.493H132.105V111.141H122.665V110.807C122.665 109.928 123.014 109.085 123.635 108.464C124.257 107.842 125.1 107.493 125.979 107.493Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M145.316 73.9318C145.524 73.6799 145.674 73.3856 145.756 73.0695C145.837 72.7534 145.849 72.4233 145.789 72.1024C145.729 71.7815 145.6 71.4775 145.41 71.212C145.22 70.9465 144.974 70.7259 144.69 70.5657L137.713 42.1466L133.253 44.0658L141.55 71.5446C141.313 72.0403 141.266 72.6058 141.417 73.1341C141.569 73.6624 141.909 74.1167 142.373 74.4109C142.837 74.7052 143.393 74.8189 143.936 74.7306C144.478 74.6423 144.969 74.3581 145.316 73.9318Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M139.875 16.4962C139.626 16.2359 139.323 16.0334 138.988 15.9029C138.652 15.7724 138.292 15.7171 137.932 15.7409C137.573 15.7646 137.223 15.8669 136.908 16.0405C136.592 16.2141 136.318 16.4548 136.106 16.7456L125.308 17.9853L126.95 22.1502L136.77 20.3123C137.283 20.6369 137.896 20.7624 138.495 20.6649C139.093 20.5674 139.635 20.2537 140.018 19.7833C140.401 19.3129 140.597 18.7185 140.571 18.1127C140.545 17.5068 140.297 16.9317 139.875 16.4962Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M122.081 70.9848L126.793 106.348L132.657 105.141C132.657 105.141 131.795 79.3864 134.727 76.2816C137.66 73.1769 130.956 67.7379 130.956 67.7379L122.081 70.9848Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M124.029 61.244L121.865 64.4909C121.865 64.4909 105.197 57.5644 105.197 68.6035C105.197 79.6426 104.244 87.1342 103.899 87.6516C103.554 88.1691 107.89 89.5118 109.959 89.1668C109.959 89.1668 112.513 71.3701 112.34 70.3352C112.34 70.3352 128.69 78.3513 131.795 77.6613C134.9 76.9714 135.633 74.529 136.151 73.1491C136.668 71.7692 135.934 60.8111 135.934 60.8111L125.585 57.653L124.029 61.244Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M124.321 41.7497L123.704 41.0093C123.704 41.0093 116.794 25.4617 119.509 21.2663C122.223 17.071 134.069 16.454 134.439 16.7008C134.81 16.9476 133.555 20.1517 134.419 21.6324C134.419 21.6324 125.243 23.6219 124.626 23.8687C124.009 24.1155 129.38 33.2355 129.38 33.2355L128.763 38.7882L124.321 41.7497Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M136.414 34.0997C136.414 34.0997 129.997 34.8401 129.75 34.8401C129.504 34.8401 129.38 33.236 129.38 33.236L123.704 41.0098C123.704 41.0098 120.908 63.5625 121.648 63.1923C122.388 62.8221 136.044 64.9481 136.167 63.961C136.29 62.9739 136.044 58.0381 136.414 57.7913C136.784 57.5445 142.83 42.2437 142.83 42.2437C142.83 42.2437 142.213 39.0355 140.116 37.9249C138.018 36.8144 136.414 34.0997 136.414 34.0997Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M140.856 40.1461L142.83 42.2438C142.83 42.2438 145.764 66.3483 144.16 67.0886C142.555 67.829 139.398 67.738 139.398 67.738L136.29 56.3107L140.856 40.1461Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M130.248 32.5731C133.385 32.5731 135.927 30.0302 135.927 26.8935C135.927 23.7568 133.385 21.214 130.248 21.214C127.111 21.214 124.568 23.7568 124.568 26.8935C124.568 30.0302 127.111 32.5731 130.248 32.5731Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M128.915 27.7798C128.838 26.6014 127.352 26.561 126.171 26.5498C124.99 26.5387 123.578 26.5808 122.91 25.6071C122.468 24.9635 122.552 24.0701 122.917 23.3802C123.282 22.6903 123.882 22.1596 124.473 21.6491C125.997 20.3312 127.568 19.0237 129.397 18.1801C131.227 17.3365 133.372 16.9956 135.269 17.6728C137.601 18.5047 140.752 22.7868 141.024 25.247C141.296 27.7072 140.313 30.2152 138.656 32.0536C136.998 33.892 133.205 33.1503 130.818 33.8043C132.269 31.7502 131.312 28.0179 128.987 27.0587L128.915 27.7798Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M78.2968 101.245C85.8268 101.245 91.9311 95.1411 91.9311 87.6111C91.9311 80.081 85.8268 73.9767 78.2968 73.9767C70.7667 73.9767 64.6624 80.081 64.6624 87.6111C64.6624 95.1411 70.7667 101.245 78.2968 101.245Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M69.1914 73.0078C67.3017 73.0079 65.4526 72.4604 63.8677 71.4313C62.2829 70.4023 61.0302 68.936 60.2614 67.2098L38.6262 18.4874C37.9095 16.8735 37.5305 15.13 37.5124 13.3642C37.4943 11.5984 37.8375 9.84756 38.521 8.21928C39.2044 6.591 40.2137 5.11969 41.4866 3.8958C42.7596 2.67191 44.2695 1.72128 45.9234 1.10236C47.5772 0.483443 49.3402 0.2093 51.104 0.296788C52.8677 0.384276 54.5949 0.831546 56.1794 1.61111C57.7639 2.39066 59.1723 3.48604 60.3179 4.82991C61.4635 6.17378 62.3222 7.73774 62.8411 9.42566L78.5076 60.382C78.9562 61.8405 79.0564 63.3839 78.8002 64.8882C78.544 66.3925 77.9386 67.8157 77.0326 69.0436C76.1266 70.2715 74.9452 71.2697 73.5834 71.9582C72.2216 72.6467 70.7173 73.0062 69.1914 73.0078Z",
    fill: "#FFE600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9235_2389"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 171,
    height: 114,
    fill: "white",
    transform: "translate(0 0.270142)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawNotify);
export default __webpack_public_path__ + "static/media/undraw-notify.75269fe5fca852182315ac91037fcba0.svg";
export { ForwardRef as ReactComponent };